import ProfileFamilyFeatures from '@/components/home/ProfileFamilyFeatures'
import ProfileImageContainer from '@/components/home/ProfileImageContainer'
import UseGetGroupsTitles from '@/hooks/FamilyProfile/useGetGroupsTitles'
import { pathes } from '@/routing/pathes'
import { icons } from '@/shahrzad-assets/shared-asstes/icons'
import { colors } from '@/shahrzad-assets/shared-constants/colors'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import CustomLoading from '@/shahrzad-assets/shared_components/CustomLoading'
import PageTitle from '@/shahrzad-assets/shared_components/PageTitle'
import { Divider } from 'antd'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

const ChooseGroup = () => {
  const { fetchGroupsTitles, groupsTitlesLoading, titles } = UseGetGroupsTitles();
  
  const navigate = useNavigate();

  const navigateToCreateGroup = (id: number,title: string) => {
    navigate(pathes.CREATE_GROUP, { state: { id , title } })
  }

  useEffect(() => {
    fetchGroupsTitles()
  }, [])

  return (
    <>
      <PageTitle title='گروه های من' />
      <ChooseGroupContainer>
        <ChooseGroupImage>
          <img src={icons.FAMILY_GROUP} alt='family-group' />
        </ChooseGroupImage>
        <GroupDescription>
          <h4>توضیحات گروه ها</h4>
          <p className='description'>
            شما می‌توانید گروه‌های مختلفی برای مدیریت اعضای خود تشکیل دهید.{' '}
            <br /> هر کدام از گروه‌ها نقش‌ها و امکانات متفاوتی نسبت به یک دیگر
            دارند.
          </p>
        </GroupDescription>
        <Features>
          <h4>امکاناتی که می توانید داشته باشید:</h4>
          <ProfileFamilyFeatures/>
        </Features>
        <ChoosingGroup>
          <h3>گروه خود را انتخاب کنید:</h3>
          {groupsTitlesLoading ? (
            <CustomLoading />
          ) : (
            <GroupList>
              {titles?.map((data, i) => (
                <GroupItem
                  onClick={() => navigateToCreateGroup(data?.id,data?.title)}
                  key={i}
                >
                  <Content>
                    <ProfileImageContainer>{data?.title?.[0]}</ProfileImageContainer>
                    <h4>{data?.title}</h4>
                    <img
                      src={icons.ARROW_LEFT_BLACK}
                      className='arrow-img'
                      alt='arrow-left'
                    />
                  </Content>
                  <Divider />
                </GroupItem>
              ))}
            </GroupList>
          )}
        </ChoosingGroup>
      </ChooseGroupContainer>
    </>
  )
}

export default ChooseGroup

const ChooseGroupContainer = styled.section``

const ChooseGroupImage = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${colors.bg3};
  margin-top: ${dimens.PAGE_TITLE_HEIGHT};
  padding: ${dimens.SPACING_XXL} 0;

  img {
    width: 18rem;
  }
`

const GroupDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${dimens.SPACING_S};
  padding: ${dimens.SPACING_XXL};

  .description {
    line-height: ${dimens.LINE_HEIGHT_LARGE};
  }
`
const Features = styled.div`
  padding: 0 ${dimens.SPACING_XXL};
  display: flex;
  flex-direction: column;
  gap: ${dimens.SPACING_S};
`
const ChoosingGroup = styled.div`
  padding: ${dimens.SPACING_XXL};

  h3 {
    margin: ${dimens.SPACING_XL} 0;
  }
`

const GroupList = styled.ul`
  display: flex;
  flex-direction: column;
`

const GroupItem = styled.li``

const Content = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: ${dimens.SPACING_XS};
  cursor: pointer;

  .arrow-img {
    position: absolute;
    left: 0.5rem;
    top: 50%;
    width: 1rem;
    aspect-ratio: 1;
    transform: translateY(-50%);
  }
`
